import LayoutsService from '../services/layouts.service';

export const layouts = {
    namespaced: true,
    state: {
        layouts: [],
        adjustedHTML: ''
    },
    getters: {
        getAllLayoutOptions: () => LayoutsService.getAllLayoutOptions(),
        getGlobals: () => LayoutsService.getGlobals(),
        adjustHTMLForLayout: () => (html, creative) => {
            return LayoutsService.adjustHTMLForLayout(html, creative);
        }
    },
    actions: {
        getAllLayoutOptions({ commit }) {
            const layouts = LayoutsService.getAllLayoutOptions();
            commit('getAllSuccess', layouts);
            return Promise.resolve(layouts);
            
        },
        getGlobals({ commit }) {
            const layouts = LayoutsService.getGlobals();
            commit('getAllSuccess', layouts);
            return Promise.resolve(layouts);
            
        },
        adjustHTMLForLayout({ commit }, html, creative) {
            const adjustedHTML = LayoutsService.adjustHTMLForLayout(html, creative);
            commit('adjustHTMLForLayoutSuccess', adjustedHTML);
            return Promise.resolve(adjustedHTML);
        }
    },
    mutations: {
        getAllSuccess(state, layouts) {
            state.layouts = layouts;
        },
        getAllFailure(state) {
            state.layouts = [];
        },
        adjustHTMLForLayoutSuccess(state, adjustedHTML) {
            state.adjustedHTML = adjustedHTML;
        }
    }
};